module.exports = __webpack_public_path__ + "static/media/helpDeskMap.29103170.png";